<div class="container-allModal position-relative">
    <div class="d-flex justify-content-end align-items-center">
        <div class="d-flex align-items-center justify-content-end">
            <span class="cursor-pointer" (click)="dialogRef.close()"
                ><i class="fa-solid fa-circle-xmark fa-2x fa-fw close-button"></i
            ></span>
        </div>
    </div>

    <images-slider [slides]="data.images" [currentIndex]="data.index"></images-slider>
</div>
